function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as e } from "./index.es33.js";
import { Link as d } from "react-router-dom";
import { clsx as f } from "./index.es105.js";
import { Typography as u } from "./index.es35.js";
import "./index.es36.js";
import { LinkKind as o } from "./index.es204.js";
import x from "./index.es205.js";
var L = function L(_ref) {
  var _ref$kind = _ref.kind,
    s = _ref$kind === void 0 ? o.default : _ref$kind,
    i = _ref.children,
    r = _ref.href,
    t = _ref.onClick,
    m = _ref.className,
    n = _ref.target,
    a = _ref.isDisabled;
  var p = _defineProperty(_defineProperty(_defineProperty({}, o.default, {
    as: "a",
    href: r,
    target: n,
    onClick: t
  }), o.routing, {
    as: d,
    to: r,
    onClick: t
  }), o.button, {
    as: "button",
    onClick: t,
    disabled: a
  })[s];
  return e.jsx(u.Body2, _objectSpread(_objectSpread({
    className: f(x.container, m)
  }, p), {}, {
    children: i
  }));
};
L.LinkKind = o;
export { L as Link };